import React, { useState, useEffect } from "react";
import { Button, TextField, CircularProgress, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";

// data
import { CreateAtmTransaction } from "./createAtmTransactions-api";
//auth
import auth from "../../../auth/auth-helper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

export default function Transactions() {
  var classes = useStyles();
  const [card_no, setCard_no] = useState([]);
  var [isLoading, setIsLoading] = useState(false);
  const [cvv, setcvv] = useState([]);
  const [amount, setAmount] = useState([]);
  var [msg, setMsg] = useState(null);
  const [branchId, setBranchId] = useState(11);
  const [accountNo, setAccountNo] = useState([]);
  const [detail, setDetail] = useState([]);

  const clickSubmit = () => {
    setIsLoading(true);
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    const transaction = {
      atm_id: card_no,
      amount: amount,
      branch_id: 11,
      account_no: accountNo,
    };

    CreateAtmTransaction(signal, credentials, transaction).then((res) => {
      setIsLoading(false);
      console.log(res);
      if (res.status === 200) {
        setMsg(res.response);
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        //setTransactions(res.response[0]);
      } else {
        setMsg(res.response);
      }
    });
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          label="Card No"
          value={card_no}
          onChange={(e) => setCard_no(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Account No"
          value={accountNo}
          onChange={(e) => setAccountNo(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="cvv"
          value={cvv}
          onChange={(e) => setcvv(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Detail"
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <div className={classes.creatingButtonContainer}>
          {isLoading ? (
            <CircularProgress size={26} />
          ) : (
            <Button
              disabled={
                card_no.length === 0 ||
                amount.length === 0 ||
                branchId.length === 0 ||
                accountNo.length === 0 ||
                detail.length === 0
              }
              variant="contained"
              color="primary"
              onClick={clickSubmit}
            >
              Continue
            </Button>
          )}
        </div>
        <Fade in={msg}>
          <Alert severity="info">
            <AlertTitle>Status</AlertTitle>
            {msg} <strong>check it out!</strong>
          </Alert>
        </Fade>
      </div>
    </form>
  );
}
